import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { IConfig } from '../interfaces/config.interface';
import { AuthService } from './auth.service';
import {BehaviorSubject, tap} from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ConfigService {
    config!: IConfig;
    private versionSubject = new BehaviorSubject<string>('');

  constructor(private httpClient: HttpClient, private authService: AuthService) {
  }

  getConfig() {
    let headers = new HttpHeaders();

    if (this.authService.isAuthenticated()) {
      headers = new HttpHeaders({
        'Authorization': `Bearer ${this.authService.getToken()}`
      });
    }

    return this.httpClient.get<any>(`${environment.backendUrl}/api/config`, { headers }).pipe(
        tap(response => {
          if (response?.data?.version) {
            this.versionSubject.next(response.data.version);
          }
        })
    );
  }
}
